import type { OrgInfo, TenantConfig, TenantTheme } from '../store/authSlice';

export function resolveDisplayLogoUrl(
  org?: OrgInfo | null,
  config?: TenantConfig | null,
  theme?: TenantTheme | null,
): string | null {
  return org?.logoUrl ?? config?.logoUrl ?? theme?.logoUrl ?? null;
}
